/* 컬러 칩(`.nt-tto`) 자리 — 모바일에서만 상품명 위로 올린다.
 *
 * ⚠️⚠️ **CSS `order` 로 풀 수 없다.** `.product__info-container` 는 block 이고 자식들의
 *    위아래 마진이 **겹쳐서**(margin collapsing) 간격을 만든다. flex·grid 로 바꾸면 겹침이
 *    사라져 간격이 전부 벌어진다 — 실측(375): 15/26/25/24/40 → **30/71/40/29/55**.
 *    그래서 레이아웃 방식을 바꾸지 않고 노드만 옮긴다.
 * ⚠️ 원래 자리는 주석 노드로 표시해 둔다. 데스크톱으로 돌아갈 때 그 자리로 되돌린다 —
 *    기억해 두지 않으면 창을 줄였다 늘린 뒤 칩이 맨 위에 남는다.
 * ⚠️ Theme Editor 가 섹션을 다시 그리면 노드가 새로 오므로 `shopify:section:load` 에서
 *    다시 배치한다(표시가 사라진 채 남지 않게).
 */
(function () {
  if (window.__ntTtoPlace) return;
  window.__ntTtoPlace = true;

  var MQ = window.matchMedia('(max-width: 749px)');

  function placeOne(tto) {
    var box = tto.closest('.product__info-container');
    if (!box) return;
    var title = box.querySelector('.product__title');
    if (!title || title === tto) return;

    if (!tto.ntAnchor || !tto.ntAnchor.parentNode) {
      var anchor = document.createComment('nt-tto');
      tto.parentNode.insertBefore(anchor, tto);
      tto.ntAnchor = anchor;
    }

    if (MQ.matches) {
      if (tto.nextSibling !== title) title.parentNode.insertBefore(tto, title);
    } else if (tto.nextSibling !== tto.ntAnchor.nextSibling) {
      tto.ntAnchor.parentNode.insertBefore(tto, tto.ntAnchor.nextSibling);
    }
  }

  function placeAll(root) {
    var list = (root || document).querySelectorAll('.nt-tto');
    for (var i = 0; i < list.length; i++) placeOne(list[i]);
  }

  function run() {
    placeAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* `change` 는 브레이크포인트를 넘을 때만 부른다 — resize 마다 도는 것보다 싸다. */
  if (MQ.addEventListener) MQ.addEventListener('change', run);
  else if (MQ.addListener) MQ.addListener(run);

  document.addEventListener('shopify:section:load', function (e) {
    placeAll(e.target);
  });
})();
